import produce from 'immer';

import { ARTICLE_TYPES, ArticleActions, ArticleState } from './articleTypes';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const initialState: ArticleState = {
  apiArticleRequestState: API_REQUEST_STATE.IDLE,
  apiArticleRequestError: null,
  apiArticlesRequestState: API_REQUEST_STATE.IDLE,
  apiArticlesRequestError: null,
  tags: [],
  article: {
    title: '',
    content: '',
    category: {
      id: 0,
      iri: '',
      name: '',
    },
    isPublished: 'false',
    isNotificationNeeded: 'false',
    keywords: [],
    tags: [],
    iri: '',
  },
  articles: [],
};

export const articleReducer = produce((draft: ArticleState, action: ArticleActions) => {
  switch (action.type) {
    case ARTICLE_TYPES.RESET:
      draft.article = initialState.article;
      break;
    case ARTICLE_TYPES.RESET_ALL:
      draft.articles = initialState.articles;
      break;
    case ARTICLE_TYPES.SET_API_ARTICLE_REQUEST_ERROR:
      draft.apiArticleRequestError = action.payload.apiArticleRequestError;
      break;
    case ARTICLE_TYPES.SET_API_ARTICLE_REQUEST_STATE:
      draft.apiArticleRequestState = action.payload.apiArticleRequestState;
      break;
    case ARTICLE_TYPES.SET_API_ARTICLES_REQUEST_ERROR:
      draft.apiArticlesRequestError = action.payload.apiArticlesRequestError;
      break;
    case ARTICLE_TYPES.SET_API_ARTICLES_REQUEST_STATE:
      draft.apiArticlesRequestState = action.payload.apiArticlesRequestState;
      break;
    case ARTICLE_TYPES.GET_ONE_SUCCESS:
      let article = {
        ...action.payload.article,
        isPublished: action.payload.article.isPublished ? 'true' : 'false',
        isNotificationNeeded: action.payload.article.isNotificationNeeded ? 'true' : 'false',
      };

      draft.article = article;
      break;
    case ARTICLE_TYPES.GET_ALL_SUCCESS:
      draft.articles = action.payload.articles;
      break;
  }
}, initialState);
